import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { Probe } from "../../../../models/eaf.models";
import { isTimestampBetweenStartAndEnd } from "../../../../utils/isTimesTampBetweenStartAndEnd";
import { EditAndDeleteButtons } from "../../components/EditAndDeleteButtons";
import { ManualAutoButton } from "../../components/ManualAutoButton";

type Props = {
	deleteProbe: (probeId: number) => void;
	editProbe: (probeId: number) => void;
	processStart?: Date;
	processEnd?: Date | null;
};
const moment = getMomentTz();

export const useTableData = ({
	deleteProbe,
	editProbe,
	processStart,
	processEnd,
}: Props) => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Probes",
			headerStyle: {
				fontSize: "0.9rem",
			},
			children: [
				{
					field: "manual-auto",
					headerName: " ",
					flex: 1,
					minWidth: 60,
					cellStyle: {
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					},
					maxWidth: 60,

					cellRenderer: (params: ICellRendererParams) => {
						return <ManualAutoButton isManual={params.data.isProbeManual} />;
					},
				},
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 60,
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return dxtToLocalServerTime(params.data.Timestamp, "HH:mm");
						}
					},
					cellStyle: (params: any) => {
						const probe = params.data as Probe;
						const isManual = probe.IsProbeManual;
						const timestamp = new Date(probe.Timestamp);

						const centeredStyle = {
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						};

						if (
							isManual &&
							processStart &&
							!isTimestampBetweenStartAndEnd(
								timestamp,
								processStart,
								processEnd ?? null,
							)
						) {
							return {
								...centeredStyle,
								backgroundColor: "#ffebee",
								border: "1px solid #f44336",
								color: "#c62828",
							};
						}
						return centeredStyle;
					},
				},
				{
					field: "Temperature",
					headerName: "Temp",
					flex: 1,
					minWidth: 60,
				},
				{
					field: "Oxygen",
					headerName: "O2",
					flex: 1,
					minWidth: 50,
				},
				{
					field: "actions",
					headerName: " ",
					flex: 1,
					minWidth: 60,
					maxWidth: 80,
					cellRenderer: EditAndDeleteButtons,
					cellRendererParams: (params: ICellRendererParams) => ({
						deleteItem: deleteProbe,
						edit: editProbe,
						id: (params.data as Probe).ProbeId,
					}),
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
	};

	return { columns, defaultColDef };
};
